export type Carrier = "SKT" | "KT" | "LGU+";

export type DeliveryStatus = "pending" | "success" | "spam" | "delivered" | "confirmed";

export interface CarrierTestResult {
  carrier: string;
  phone: string;
  name?: string;
  status: "success" | "fail" | "blocked";
  delivery_status?: DeliveryStatus;
  message_id?: string;
  sent_at?: string;
  error?: string;
}

export interface CarrierReviewResult {
  carrier: string;
  status: "success" | "spam";
  note?: string;
  reviewed_at?: string;
}

export interface CarrierTestRecord {
  id: string;
  message: string;
  type: string;
  carriers: string[];
  total_count: number;
  success_count: number;
  fail_count: number;
  blocked_count: number;
  status: string;
  results: CarrierTestResult[];
  review_results: CarrierReviewResult[];
  reviewed_at?: string;
  reviewed_by?: string;
  needs_review?: boolean;
  created_at: string;
}

export interface CarrierConfig {
  carrier: Carrier;
  phone: string;
  selected: boolean;
}

export const CARRIER_STYLES: Record<
  Carrier,
  { border: string; bg: string; check: string; label: string; text: string; dot: string }
> = {
  SKT: {
    border: "border-red-500/30",
    bg: "bg-red-500/10",
    check: "text-red-500",
    label: "text-red-500",
    text: "text-red-400",
    dot: "bg-red-400",
  },
  KT: {
    border: "border-sky-500/30",
    bg: "bg-sky-500/10",
    check: "text-sky-500",
    label: "text-sky-500",
    text: "text-sky-400",
    dot: "bg-sky-400",
  },
  "LGU+": {
    border: "border-pink-500/30",
    bg: "bg-pink-500/10",
    check: "text-pink-500",
    label: "text-pink-500",
    text: "text-pink-400",
    dot: "bg-pink-400",
  },
};

export const DEFAULT_CARRIERS: CarrierConfig[] = [
  { carrier: "SKT", phone: "", selected: true },
  { carrier: "KT", phone: "", selected: true },
  { carrier: "LGU+", phone: "", selected: true },
];